import { memo } from 'react';

/**
 * PageSkeleton - Mobile-first skeleton for page loading
 * Respects final layout to prevent layout shifts
 */
export const PageSkeleton = memo(() => (
  <div className="flex flex-col min-h-[calc(100dvh-140px)] p-4 space-y-4 animate-pulse">
    <div className="h-24 bg-muted rounded-2xl" />
    <div className="h-16 bg-muted rounded-xl" />
    <div className="h-40 bg-muted rounded-2xl" />
    <div className="h-32 bg-muted rounded-2xl" />
  </div>
));
PageSkeleton.displayName = 'PageSkeleton';
